var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.578,
    height: 8.34,
    viewBox: "0 0 14.578 8.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_1_",
    "data-name": "chevron-down (1)",
    d: "M1.652,4.652a.52.52,0,0,1,.736,0l5.869,5.87,5.869-5.87a.52.52,0,0,1,.736.736L8.625,11.625a.52.52,0,0,1-.736,0L1.652,5.388a.52.52,0,0,1,0-.736Z",
    transform: "translate(15.577 12.278) rotate(180)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.7b48aeaf246f328df9a2c1b23c382557.svg";
export { ForwardRef as ReactComponent };